/**
 * 移入批次 / 移动包牌抽屉入口：
 * - 线上口径（包裹移入延期开关关闭）：接入后端的 [MoveInBackendDrawer]（Q29）
 * - 开关开启：保留的演示实现 [MoveInMockDrawer]（含包裹移入、移入时新建包牌等延期功能，前端 plan D12）
 */
import React from 'react';

import { ENABLE_PARCEL_MOVE_IN } from '../constants';
import { MoveInBackendDrawer } from './MoveInBackendDrawer';
import { MoveInMockDrawer } from './MoveInMockDrawer';
import { MoveInDrawerProps } from './overlayProps';

export const MoveInDrawer: React.FC<MoveInDrawerProps> = (props) =>
    (ENABLE_PARCEL_MOVE_IN ? <MoveInMockDrawer {...props} /> : <MoveInBackendDrawer {...props} />);
